import UserEntitlementService from 'src/modules/userEntitlement/userEntitlementService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'USERENTITLEMENT_FORM';

const userEntitlementFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userEntitlementFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await UserEntitlementService.find(id);
      }

      dispatch({
        type: userEntitlementFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userEntitlementFormActions.INIT_ERROR,
      });

      getHistory().push('/user-entitlement');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: userEntitlementFormActions.CREATE_STARTED,
      });

      await UserEntitlementService.create(values);

      dispatch({
        type: userEntitlementFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.userEntitlement.create.success'),
      );

      getHistory().push('/user-entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userEntitlementFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: userEntitlementFormActions.UPDATE_STARTED,
      });

      await UserEntitlementService.update(id, values);

      dispatch({
        type: userEntitlementFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.userEntitlement.update.success'),
      );

      getHistory().push('/user-entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userEntitlementFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default userEntitlementFormActions;
